// extracted by mini-css-extract-plugin
export default {"wrapper":"ClassDirectLink_wrapper__BCnqW"};